import LANGUAGES_LIST from "../constants/langData";

export function validate(code: $TSFixMe) {
  return Object.prototype.hasOwnProperty.call(LANGUAGES_LIST, code);
}

export function getLanguageName(code: $TSFixMe) {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return validate(code) ? LANGUAGES_LIST[code].name : "";
}

export function getNativeLanguageName(code: $TSFixMe) {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return validate(code) ? LANGUAGES_LIST[code].nativeName : "";
}

/* istanbul ignore next */
export function getAllLanguageNames() {
  return Object.values(LANGUAGES_LIST).map((l) => l.name);
}

/* istanbul ignore next */
export function getAllLanguageCodes() {
  return Object.keys(LANGUAGES_LIST);
}

/* istanbul ignore next */
export function getAllNativeLanguageNames() {
  return Object.values(LANGUAGES_LIST).map((l) => l.nativeName);
}

export function getLanguages(codes = []) {
  return codes.map((code) => ({
    code,
    name: getLanguageName(code),
    nativeName: getNativeLanguageName(code),
  }));
}

export function getLanguageCode(name: $TSFixMe) {
  const code = Object.keys(LANGUAGES_LIST).find((c) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const language = LANGUAGES_LIST[c];

    return (
      language.name.toLowerCase() === name.toLowerCase() ||
      language.nativeName.toLowerCase() === name.toLowerCase()
    );
  });
  return code || "";
}
/* istanbul ignore next */
export function getLanguagesList() {
  const codes = getAllLanguageCodes();
  return codes.map((code) => ({ id: code, code, name: getLanguageName(code) }));
}
